import { USER_ROLE, DEFAULT_ROLES } from './userRole'

export const PATH_NAME = {
  LOGIN_PAGE: { path: '/login' },
  PROVIDER_LOGIN_PAGE: { path: '/provider-login' },
  REGISTER_SERIAL_NUMBER_PAGE: { path: '/registerserialnumber' },
  TERMS_OF_SERVICE_PAGE: { path: '/termsofservice', requiredRoles: DEFAULT_ROLES },
  UPGRADE_PAGE: { path: '/upgradestatus' },
  SEARCH_GLOBAL: {
    path: '/GlobalSearchResult',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN, USER_ROLE.READONLY]
  },
  SEARCH_TERMS_PAGE: {
    path: '/GlobalSearchResult?searchTerms=',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  DASHBOARD: {
    path: '/dashboard',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY, USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  PROFILE_SETTING: {
    path: '/account',
    requiredRoles: Object.values(USER_ROLE)
  },
  GROUPS_PAGE: {
    path: '/groups',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]
  },
  GROUPS_FLEET: {
    path: '/groups?fleetId=',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  GROUPS_PAGE_DETAIL_PATH: {
    path: '/groups/details/',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]
  },
  GROUPS_PAGE_DETAIL: {
    path: '/groups/details/:groupId',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]
  },
  DEVICES: { path: '/devices', requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]},
  DEVICES_DETAIL_PAGE_PATH: {
    path: '/devices/details/',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]
  },
  DEVICES_DETAIL_PAGE: {
    path: '/devices/details/:deviceId',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]
  },
  ALERTS_PAGE: {
    path: '/alerts',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.INFRASTRUCTURETECHNICIAN, USER_ROLE.INFRASTRUCTUREMANAGER]
  },
  ASSETS_MAIN_MENU: {
    path: '/assets',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]
  },
  ASSETS_PAGE: {
    path: '/assets/assets',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]
  },
  ASSET_DETAILS_PAGE: {
    path: '/assets/assets/details',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.READONLY]
  },
  SFE_MANAGEMENT: {
    path: '/assets/sfe-management',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  ACTIVITY_PAGE: {
    path: '/activity/',
    requiredRoles: [
      USER_ROLE.MANAGER,
      USER_ROLE.MAINTAINER,
      USER_ROLE.ADMIN,
      USER_ROLE.INFRASTRUCTUREMANAGER,
      USER_ROLE.INFRASTRUCTURETECHNICIAN,
      USER_ROLE.INFRASTRUCTUREMANAGER
    ]
  },
  ACTIVITY_JOBS_PAGE: {
    path: '/activity/installerjobs',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  ACTIVITY_INFRASTRUCTURE_JOBS_PAGE: {
    path: '/activity/infrastructureinstallerjobs',
    requiredRoles: [USER_ROLE.INFRASTRUCTURETECHNICIAN, USER_ROLE.INFRASTRUCTUREMANAGER]
  },
  ACTIVITY_REGISTRATION_PAGE: {
    path: '/activity/registrations',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  ACTIVITY_AGENT_QUEUE_PAGE: {
    path: '/activity/agentqueue',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  ACTIVITY_AUDIT_LOG_PAGE: {
    path: '/activity/AuditLogs',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER, USER_ROLE.ADMIN, USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  CONFIGURATION_PAGE: {
    path: '/configuration/',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  FIRMWARES_PAGE: {
    path: '/configuration/firmware',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  FIRMWARES_DETAIL: {
    path: '/configuration/firmware/:firmwareId',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  DEVICE_APPLICATIONS: {
    path: '/configuration/deviceapplications',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  DEVICE_APPLICATION_DETAILS: {
    path: '/configuration/deviceapplications/:id',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  SUPPORTING_APPLICATIONS: {
    path: '/configuration/supportingapplications/',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  SUPPORTING_APPLICATION_DETAILS: {
    path: '/configuration/supportingapplications/:applicationId',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  CUSTOMIZATION_PROFILES: {
    path: '/configuration/customizationprofiles',
    requiredRoles: [USER_ROLE.MANAGER, USER_ROLE.MAINTAINER]
  },
  FACTORYSETTINGS: { path: '/configuration/factorysettings', requiredRoles: [USER_ROLE.MANAGER] },
  ADMIN: { path: '/admin', requiredRoles: [USER_ROLE.ADMIN] },

  BASESTATION_GROUPS_PAGE_PATH: {
    path: '/infrastructure/basestation/groups',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  BASESTATION_GROUP_DETAILS: {
    path: '/infrastructure/basestation/groups/:id',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  BASESTATION_DETAILS_PAGE_PATH: {
    path: '/infrastructure/basestation/details',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  BASESTATION_DETAILS: {
    path: '/infrastructure/basestation/details/:id',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  BASESTATION_HARDWARE_PAGE_PATH: {
    path: '/infrastructure/basestation/hardware',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  BASESTATION_FIRMWARES_PAGE: {
    path: '/infrastructure/basestation/firmware',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  BASESTATION_FIRMWARES_DETAIL: {
    path: '/infrastructure/basestation/firmware/:firmwareId',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  CERTIFICATES_PAGE_PATH: {
    path: '/infrastructure/certificates',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER]
  },
  CERTIFICATE_DETAIL: {
    path: '/infrastructure/certificates/:id',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER]
  },

  USERS: { path: '/admin/users', requiredRoles: [USER_ROLE.ADMIN] },
  UPDATE_USER: {
    path: '/admin/users/:userName',
    requiredRoles: [USER_ROLE.ADMIN]
  },
  UPDATE_USER_PATH: { path: '/admin/users/', requiredRoles: [USER_ROLE.ADMIN] },
  CREATE_USER: { path: '/admin/users/create', requiredRoles: [USER_ROLE.ADMIN] },
  OTAP_AGENTS: { path: '/admin/otapAgents', requiredRoles: [USER_ROLE.ADMIN] },
  OTAP_AGENT_DETAILS: {
    path: '/admin/otapAgents/:otapAgentId',
    requiredRoles: [USER_ROLE.ADMIN]
  },
  SECURITY_KEYS: { path: '/admin/SecurityKeys', requiredRoles: [USER_ROLE.ADMIN] },
  SECURITY_KEY_DETAILS: {
    path: '/admin/SecurityKeys/:serialNumber',
    requiredRoles: [USER_ROLE.ADMIN]
  },
  ENABLEFLEET_LICENSES: {
    path: '/admin/enablefleetlicenses',
    requiredRoles: [USER_ROLE.ADMIN]
  },
  LOG_FILES: { path: '/admin/logfiles', requiredRoles: [USER_ROLE.ADMIN] },
  LOG_FILES_CATEGORY: {
    path: '/admin/logfiles/logs/:category',
    requiredRoles: [USER_ROLE.ADMIN]
  },
  LOG_FILES_WINDOW_USER: {
    path: '/admin/logfiles/logs/:category/:windowsUser',
    requiredRoles: [USER_ROLE.ADMIN]
  },
  FLEETS: { path: '/admin/fleets', requiredRoles: [USER_ROLE.ADMIN] },
  SETTINGS: { path: '/admin/settings', requiredRoles: [USER_ROLE.ADMIN] },
  HANGFIRE: { path: '/hangfire', requiredRoles: [USER_ROLE.ADMIN] },
  SWAGGER: { path: '/swagger', requiredRoles: [USER_ROLE.ADMIN] },
  FILE_SYSTEM: { path: '/admin/filesystem', requiredRoles: [USER_ROLE.ADMIN] },
  LOG_ERRORS: { path: '/admin/logfiles/errors', requiredRoles: [USER_ROLE.ADMIN] },
  DATABASE_LOGS: { path: '/admin/databaselogs', requiredRoles: [USER_ROLE.ADMIN] },
  REPORT: { path: '/report', requiredRoles: [USER_ROLE.ADMIN] },
  CHANGE_PASSWORD: { path: '/account/changepassword', requiredRoles: DEFAULT_ROLES },
  SERVER_ERROR: { path: '/ServerError' },
  NOT_AUTHORIZED: { path: '/NotAuthorized' },
  BASESTATION_PAGE: {
    path: '/infrastructure/basestation',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  },
  BASESTATION_FIRMWARE_PAGE: {
    path: '/infrastructure/basestation/firmware',
    requiredRoles: [USER_ROLE.INFRASTRUCTUREMANAGER, USER_ROLE.INFRASTRUCTURETECHNICIAN]
  }
}
